module.exports = __webpack_public_path__ + "img/ex5.0d745b49.png";